import axios from 'axios';
import { API_BASE_URL } from '../config/api';

interface ChatResponse {
  response: string;
  ads: Array<{
    id: number;
    title: string;
    description: string;
    category: string;
    target_keywords: string[];
    ctr: number;
  }>;
  keywords: string[];
}

/**
 * Send a chat request to the API
 * @param prompt The user's prompt
 * @returns The chat response with AI-generated content and ads
 */
export const sendChatRequest = async (prompt: string): Promise<ChatResponse> => {
  try {
    const result = await axios.post<ChatResponse>(`${API_BASE_URL}/chat/`, {
      prompt: prompt.trim()
    });
    return result.data;
  } catch (error) {
    console.error('Error in chat request:', error);
    throw error;
  }
};

export default {
  sendChatRequest,
}; 